module.exports = __webpack_public_path__ + "static/media/png.fcc3c867.svg";